import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { CATEGORY_META } from "@/mocks/films";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 欧美成人电影",
    description: "你访问的页面不存在或已被移动，请返回首页继续浏览欧美成人电影的影片资料与分类资讯。",
    keywords: "欧美成人电影,页面不存在",
    canonicalPath: "/",
  });

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl mx-auto text-center">
          <p className="font-heading text-[88px] md:text-[120px] leading-none font-semibold text-background-300 select-none">
            404
          </p>
          <h1 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            页面不存在或已被移动
          </h1>
          <p className="mt-3 text-sm text-foreground-600">
            无法找到路径 <span className="font-mono text-foreground-800 break-all">{location.pathname}</span>，
            你可以返回首页或从下方分类继续浏览。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="h-10 px-5 rounded-md bg-primary-900 text-background-50 text-sm font-medium flex items-center whitespace-nowrap hover:bg-primary-800 transition-colors"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="h-10 px-5 rounded-md border border-background-300 text-foreground-700 text-sm flex items-center whitespace-nowrap hover:border-accent-400 transition-colors"
            >
              前往搜索
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {CATEGORY_META.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-1.5 rounded-md bg-background-100 border border-background-200 text-[12px] text-foreground-700 hover:border-accent-300 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}